module.exports = __webpack_public_path__ + "static/media/success_prize.3c7a840f.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/share/img/success_prize.png
// module id = 1537
// module chunks = 0